var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;stroke:#fff;stroke-width:0}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.779,9.635L42.77,7.23l-2.404-6.01L37.22,4.365C33.521,2.17,29.318,1,25,1C11.767,1,1,11.767,1,25s10.767,24,24,24 s24-10.767,24-24c0-4.318-1.17-8.521-3.365-12.22L48.779,9.635z M41.23,8.77l3.99,1.596l-2.462,2.461L38.77,11.23l-1.596-3.989 l2.461-2.462L41.23,8.77z M47,25c0,12.131-9.869,22-22,22S3,37.131,3,25S12.869,3,25,3c3.788,0,7.485,0.971,10.767,2.818 l-0.941,0.941l2,5.001l-1.259,1.259C32.746,10.526,29.052,9,25,9C16.178,9,9,16.178,9,25s7.178,16,16,16s16-7.178,16-16 c0-4.052-1.526-7.746-4.018-10.568l1.259-1.259l5.001,2l0.941-0.941C46.029,17.515,47,21.212,47,25z M31,25c0,3.309-2.691,6-6,6 s-6-2.691-6-6s2.691-6,6-6c1.294,0,2.49,0.416,3.471,1.115l-2.959,2.959C25.347,23.031,25.178,23,25,23c-1.104,0-2,0.895-2,2 c0,1.105,0.896,2,2,2s2-0.895,2-2c0-0.178-0.031-0.347-0.074-0.512l2.959-2.959C30.584,22.51,31,23.706,31,25z M29.898,18.688 C28.542,17.634,26.846,17,25,17c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8c0-1.846-0.634-3.542-1.688-4.898l4.257-4.257 C37.7,18.303,39,21.499,39,25c0,7.72-6.28,14-14,14s-14-6.28-14-14s6.28-14,14-14c3.5,0,6.697,1.3,9.154,3.432L29.898,18.688z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.8fce0fe7602e76351386f3d6ac3bb019.svg";
export { ForwardRef as ReactComponent };